export const RENDICION_API_URL = process.env.NEXT_PUBLIC_RENDICION_API_URL;
export const SESSION_COOKIE = "__rendicion_session";
export const LOCAL_STORAGE_SESSION = "__rendicion_session";
